export const navItems = [
  {
    name: 'Beheer', url: '/manage', accessPath: '',
    menuItems: [
      { name: 'Errors', url: '/errorevents', accessPath: 'errorevent' },
      { name: 'ApiEvents', url: '/apievents', accessPath: 'apievent' },
      { name: 'Gebruikers', url: '/users', accessPath: 'user' },
      { name: 'Firma\'s', url: '/companies', accessPath: 'company' },
      { name: 'Chauffeurs', url: '/drivers', accessPath: 'driver' },
      { name: 'Afwezigheden', url: '/driverabsences', accessPath: 'driverabsence' },
      { name: 'Klanten', url: '/customers', accessPath: 'customer' },
      { name: 'Project Prijs', url: '/projectprice', accessPath: 'job' },
      { name: 'Configuratie', url: '/configparams', accessPath: 'customer' }
    ]
  },
  {
    name: 'Templates', url: '/templates', accessPath: '',
    menuItems: [
      { name: 'Documenten', url: '/docs', accessPath: 'doctemplate' },
      { name: 'Emails', url: '/emails', accessPath: 'emailtemplate' }
    ]
  },
  {
    name: 'Voertuig', url: '/vehicle', accessPath: '',
    menuItems: [
      { name: 'Voertuigen', url: '/vehicles', accessPath: 'vehicle' },
      { name: 'ChassisNummers', url: '/chassisnumbers', accessPath: 'chassisnumber' },
      { name: 'Vergunningen', url: '/licenses', accessPath: 'license' },
      { name: 'Vergunning Categories', url: '/licensecategories', accessPath: 'licensecategory' }
    ]
  },
  {
    name: 'Werk', url: '/jobs', accessPath: 'job'
  },
  {
    name: 'Planning', url: '/planning', accessPath: 'job'
  },
  {
    name: 'Verkoop', url: '/sales', accessPath: 'sale'
  },
  { name: 'Bonnen', url: '/transportvouchers', accessPath: 'transportvoucher' }
];
